export function initSearch(): void {
  const dialog = document.querySelector<HTMLDialogElement>("[data-search-dialog]");
  const form = document.querySelector<HTMLFormElement>("[data-search-form]");
  const input = document.querySelector<HTMLInputElement>("#search-input");
  const results = document.querySelector<HTMLElement>("[data-search-results]");
  if (!dialog || !form || !input || !results) return;
  let timer = 0;
  let request: AbortController | undefined;
  let version = 0;
  let trigger: HTMLElement | null = null;

  function cancel(): void {
    clearTimeout(timer);
    request?.abort();
    version += 1;
  }
  function open(): void {
    if (!dialog || !input || dialog.open) return;
    trigger = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    dialog.showModal();
    input.focus();
  }
  async function search(): Promise<void> {
    if (!input || !results || !dialog?.open) return;
    cancel();
    const query = input.value.trim();
    if (!query) {
      results.textContent = "请输入服务商名称或文章关键词。";
      return;
    }
    const current = version;
    request = new AbortController();
    results.textContent = "正在搜索…";
    try {
      const response = await fetch(`/api/v1/search?q=${encodeURIComponent(query)}`, { signal: request.signal });
      if (!response.ok) throw new Error("Search failed");
      const data = await response.json() as { items: Array<{ title: string; type: string; summary: string; href: string }> };
      if (current !== version || !dialog.open) return;
      results.replaceChildren();
      for (const item of data.items) {
        const url = new URL(item.href, location.origin);
        if (url.origin !== location.origin) continue;
        const link = document.createElement("a");
        link.className = "search-result";
        link.href = url.href;
        const title = document.createElement("strong");
        title.textContent = item.title;
        const detail = document.createElement("small");
        detail.textContent = `${item.type} · ${item.summary}`;
        link.append(title, detail);
        results.append(link);
      }
      if (!results.childElementCount) results.textContent = `没有找到“${query}”相关内容，试试其他关键词。`;
    } catch (error) {
      if (current !== version || (error instanceof DOMException && error.name === "AbortError")) return;
      results.textContent = "搜索暂时不可用，请稍后重试。";
    }
  }
  document.querySelector("[data-search-open]")?.addEventListener("click", open);
  document.addEventListener("keydown", (event) => {
    const target = event.target;
    const editing = target instanceof HTMLElement && (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName));
    if (event.key === "/" && !editing && !event.ctrlKey && !event.metaKey && !event.altKey && !dialog.open) {
      event.preventDefault();
      open();
    }
  });
  form.addEventListener("submit", (event) => { event.preventDefault(); void search(); });
  input.addEventListener("input", (event) => {
    cancel();
    results.replaceChildren();
    if ((event as InputEvent).isComposing || !input.value.trim()) return;
    timer = window.setTimeout(() => void search(), 180);
  });
  input.addEventListener("compositionend", () => {
    cancel();
    if (input.value.trim()) timer = window.setTimeout(() => void search(), 180);
  });
  dialog.addEventListener("click", (event) => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener("close", () => {
    cancel();
    input.value = "";
    results.replaceChildren();
    trigger?.focus();
  });
}
